import React from 'react';
import PropTypes from 'prop-types';
import TagManager from 'services/TagManager';
import Link from 'components/Link';
import style from './style.scss';//NOSONAR

const RecipeInfo = (props) => {
    const recipeInfo = props.data ? props.data : '';
    const visible = (recipeInfo.time_description && recipeInfo.time_description.visible) && (recipeInfo.portions && recipeInfo.portions.visible) && (recipeInfo.Ingredients && recipeInfo.Ingredients.visible);

    const interactionClick = (title) => {
        TagManager.clickLink('Ver todas las ofertas','Recipes',title);
    }

    return (
        <div className="recipe-info">
            <div className="recipe-info-title-wrap">
                <div className="recipe-info-title">{recipeInfo.title}</div>
                <Link className="recipe-info-link" to={recipeInfo.url} target={recipeInfo.url_target} onClick={() => interactionClick(recipeInfo.title)}>
                    <span className='recipe-info-link-text'>Ver productos</span>
                </Link>
            </div>
            
            <div className="recipe-info-description">{recipeInfo.description}</div>

            {(visible === true) && <div className="recipe-info-ingredients-wrap">
                <div className="recipe-preparation-time-wrap">
                    <div className="recipe-preparation-time-title-wrap">
                        <i className="recipe-preparation-time-icon jumbo-icon-clock"></i>
                        <span className="recipe-preparation-time-title">Tiempo preparación</span>
                    </div>
                    <div className="recipe-preparation-time-description">
                        <span>{recipeInfo.time_description.description}</span>
                    </div>
                </div>

                <div className="recipe-porcions-wrap">
                    <div className="recipe-porcions-title-wrap">
                        <i className="recipe-porcions-icon jumbo-icon-user"></i>
                        <span className="recipe-porcions-title">Porciones</span>
                    </div>
                    <div className="recipe-porcions-description">
                        <span>{recipeInfo.portions.description}</span>
                    </div>
                </div>

                <div className="recipe-ingredients-wrap">
                    <div className="recipe-porcions-title-wrap">
                        <i className="recipe-ingredients-icon jumbo-icon-new-basket"></i>
                        <span className="recipe-ingredients-title">Ingredientes</span>
                    </div>
                    <div className="recipe-ingredients-description">
                        <span>{recipeInfo.Ingredients.description}</span>
                    </div>
                </div>
            </div>}
        </div>
    )
}

RecipeInfo.propTypes = {
    data: PropTypes.object
}

export default RecipeInfo;